import Crud from '../components/Branches/Crud'
import Entity from '../components/Branches/Add'
import View from '../components/Branches/View'

let routes = {
    path: '/branches',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/branches/add',
            name: 'Nova Filial',
            component: Entity
        },
        {
            path: '/branches/edit/:id?',
            name: 'Editar Filial',
            component: Entity
        },
        {
            path: '/branches',
            name: 'Filiais',
            component: Crud
        },
        {
            path: '/branches/view/:id?',
            name: 'Visualizar Filial',
            component: View
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/branch.js